/**
 * Language Enum
 * 支援的語言代碼列表，使用Azure語音服務標準
 * 格式為：語言代碼-國家/地區代碼
 */
export enum LanguageEnum {
	/**
	 * 南非荷蘭語 (南非)
	 */
	Afrikaans_South_Africa = 'af-ZA',

	/**
	 * 阿姆哈拉語 (埃塞俄比亞)
	 */
	Amharic_Ethiopia = 'am-ET',

	/**
	 * 阿拉伯語 (阿聯酋)
	 */
	Arabic_United_Arab_Emirates = 'ar-AE',

	/**
	 * 阿拉伯語 (巴林)
	 */
	Arabic_Bahrain = 'ar-BH',

	/**
	 * 阿拉伯語 (阿爾及利亞)
	 */
	Arabic_Algeria = 'ar-DZ',

	/**
	 * 阿拉伯語 (埃及)
	 */
	Arabic_Egypt = 'ar-EG',

	/**
	 * 阿拉伯語 (以色列)
	 */
	Arabic_Israel = 'ar-IL',

	/**
	 * 阿拉伯語 (伊拉克)
	 */
	Arabic_Iraq = 'ar-IQ',

	/**
	 * 阿拉伯語 (約旦)
	 */
	Arabic_Jordan = 'ar-JO',

	/**
	 * 阿拉伯語 (科威特)
	 */
	Arabic_Kuwait = 'ar-KW',

	/**
	 * 阿拉伯語 (黎巴嫩)
	 */
	Arabic_Lebanon = 'ar-LB',

	/**
	 * 阿拉伯語 (利比亞)
	 */
	Arabic_Libya = 'ar-LY',

	/**
	 * 阿拉伯語 (摩洛哥)
	 */
	Arabic_Morocco = 'ar-MA',

	/**
	 * 阿拉伯語 (阿曼)
	 */
	Arabic_Oman = 'ar-OM',

	/**
	 * 阿拉伯語 (巴勒斯坦)
	 */
	Arabic_Palestinian_Authority = 'ar-PS',

	/**
	 * 阿拉伯語 (卡塔爾)
	 */
	Arabic_Qatar = 'ar-QA',

	/**
	 * 阿拉伯語 (沙特阿拉伯)
	 */
	Arabic_Saudi_Arabia = 'ar-SA',

	/**
	 * 阿拉伯語 (敘利亞)
	 */
	Arabic_Syria = 'ar-SY',

	/**
	 * 阿拉伯語 (突尼斯)
	 */
	Arabic_Tunisia = 'ar-TN',

	/**
	 * 阿拉伯語 (也門)
	 */
	Arabic_Yemen = 'ar-YE',

	/**
	 * 阿薩姆語 (印度)
	 */
	Assamese_India = 'as-IN',

	/**
	 * 亞塞拜然語 拉丁文 (亞塞拜然)
	 */
	Azerbaijani_Latin_Azerbaijan = 'az-AZ',

	/**
	 * 保加利亞語 (保加利亞)
	 */
	Bulgarian_Bulgaria = 'bg-BG',

	/**
	 * 孟加拉語 (印度)
	 */
	Bengali_India = 'bn-IN',

	/**
	 * 波斯尼亞語 (波斯尼亞和黑塞哥維那)
	 */
	Bosnian_Bosnia_and_Herzegovina = 'bs-BA',

	/**
	 * 加泰羅尼亞語
	 */
	Catalan = 'ca-ES',

	/**
	 * 捷克語 (捷克)
	 */
	Czech_Czechia = 'cs-CZ',

	/**
	 * 威爾士語 (英國)
	 */
	Welsh_United_Kingdom = 'cy-GB',

	/**
	 * 丹麥語 (丹麥)
	 */
	Danish_Denmark = 'da-DK',

	/**
	 * 德語 (奧地利)
	 */
	German_Austria = 'de-AT',

	/**
	 * 德語 (瑞士)
	 */
	German_Switzerland = 'de-CH',

	/**
	 * 德語 (德國)
	 */
	German_Germany = 'de-DE',

	/**
	 * 希臘語 (希臘)
	 */
	Greek_Greece = 'el-GR',

	/**
	 * 英語 (澳大利亞)
	 */
	English_Australia = 'en-AU',

	/**
	 * 英語 (加拿大)
	 */
	English_Canada = 'en-CA',

	/**
	 * 英語 (英國)
	 */
	English_United_Kingdom = 'en-GB',

	/**
	 * 英語 (加納)
	 */
	English_Ghana = 'en-GH',

	/**
	 * 英語 (香港特別行政區)
	 */
	English_Hong_Kong_SAR = 'en-HK',

	/**
	 * 英語 (愛爾蘭)
	 */
	English_Ireland = 'en-IE',

	/**
	 * 英語 (印度)
	 */
	English_India = 'en-IN',

	/**
	 * 英語 (肯亞)
	 */
	English_Kenya = 'en-KE',

	/**
	 * 英語 (奈及利亞)
	 */
	English_Nigeria = 'en-NG',

	/**
	 * 英語 (紐西蘭)
	 */
	English_New_Zealand = 'en-NZ',

	/**
	 * 英語 (菲律賓)
	 */
	English_Philippines = 'en-PH',

	/**
	 * 英語 (新加坡)
	 */
	English_Singapore = 'en-SG',

	/**
	 * 英語 (坦桑尼亞)
	 */
	English_Tanzania = 'en-TZ',

	/**
	 * 英語 (美國)
	 */
	English_United_States = 'en-US',

	/**
	 * 英語 (南非)
	 */
	English_South_Africa = 'en-ZA',

	/**
	 * 西班牙語 (阿根廷)
	 */
	Spanish_Argentina = 'es-AR',

	/**
	 * 西班牙語 (玻利維亞)
	 */
	Spanish_Bolivia = 'es-BO',

	/**
	 * 西班牙語 (智利)
	 */
	Spanish_Chile = 'es-CL',

	/**
	 * 西班牙語 (哥倫比亞)
	 */
	Spanish_Colombia = 'es-CO',

	/**
	 * 西班牙語 (哥斯大黎加)
	 */
	Spanish_Costa_Rica = 'es-CR',

	/**
	 * 西班牙語 (古巴)
	 */
	Spanish_Cuba = 'es-CU',

	/**
	 * 西班牙語 (多明尼加共和國)
	 */
	Spanish_Dominican_Republic = 'es-DO',

	/**
	 * 西班牙語 (厄瓜多爾)
	 */
	Spanish_Ecuador = 'es-EC',

	/**
	 * 西班牙語 (西班牙)
	 */
	Spanish_Spain = 'es-ES',

	/**
	 * 西班牙語 (赤道幾內亞)
	 */
	Spanish_Equatorial_Guinea = 'es-GQ',

	/**
	 * 西班牙語 (瓜地馬拉)
	 */
	Spanish_Guatemala = 'es-GT',

	/**
	 * 西班牙語 (宏都拉斯)
	 */
	Spanish_Honduras = 'es-HN',

	/**
	 * 西班牙語 (墨西哥)
	 */
	Spanish_Mexico = 'es-MX',

	/**
	 * 西班牙語 (尼加拉瓜)
	 */
	Spanish_Nicaragua = 'es-NI',

	/**
	 * 西班牙語 (巴拿馬)
	 */
	Spanish_Panama = 'es-PA',

	/**
	 * 西班牙語 (秘魯)
	 */
	Spanish_Peru = 'es-PE',

	/**
	 * 西班牙語 (波多黎各)
	 */
	Spanish_Puerto_Rico = 'es-PR',

	/**
	 * 西班牙語 (巴拉圭)
	 */
	Spanish_Paraguay = 'es-PY',

	/**
	 * 西班牙語 (薩爾瓦多)
	 */
	Spanish_El_Salvador = 'es-SV',

	/**
	 * 西班牙語 (美國)
	 */
	Spanish_United_States = 'es-US',

	/**
	 * 西班牙語 (烏拉圭)
	 */
	Spanish_Uruguay = 'es-UY',

	/**
	 * 西班牙語 (委內瑞拉)
	 */
	Spanish_Venezuela = 'es-VE',

	/**
	 * 愛沙尼亞語 (愛沙尼亞)
	 */
	Estonian_Estonia = 'et-EE',

	/**
	 * 巴斯克語
	 */
	Basque = 'eu-ES',

	/**
	 * 波斯語 (伊朗)
	 */
	Persian_Iran = 'fa-IR',

	/**
	 * 芬蘭語 (芬蘭)
	 */
	Finnish_Finland = 'fi-FI',

	/**
	 * 菲律賓語 (菲律賓)
	 */
	Filipino_Philippines = 'fil-PH',

	/**
	 * 法語 (比利時)
	 */
	French_Belgium = 'fr-BE',

	/**
	 * 法語 (加拿大)
	 */
	French_Canada = 'fr-CA',

	/**
	 * 法語 (瑞士)
	 */
	French_Switzerland = 'fr-CH',

	/**
	 * 法語 (法國)
	 */
	French_France = 'fr-FR',

	/**
	 * 愛爾蘭語 (愛爾蘭)
	 */
	Irish_Ireland = 'ga-IE',

	/**
	 * 加利西亞語
	 */
	Galician = 'gl-ES',

	/**
	 * 古吉拉特語 (印度)
	 */
	Gujarati_India = 'gu-IN',

	/**
	 * 希伯來語 (以色列)
	 */
	Hebrew_Israel = 'he-IL',

	/**
	 * 印地語 (印度)
	 */
	Hindi_India = 'hi-IN',

	/**
	 * 克羅埃西亞語 (克羅埃西亞)
	 */
	Croatian_Croatia = 'hr-HR',

	/**
	 * 匈牙利語 (匈牙利)
	 */
	Hungarian_Hungary = 'hu-HU',

	/**
	 * 亞美尼亞語 (亞美尼亞)
	 */
	Armenian_Armenia = 'hy-AM',

	/**
	 * 印尼語 (印尼)
	 */
	Indonesian_Indonesia = 'id-ID',

	/**
	 * 冰島語 (冰島)
	 */
	Icelandic_Iceland = 'is-IS',

	/**
	 * 義大利語 (瑞士)
	 */
	Italian_Switzerland = 'it-CH',

	/**
	 * 義大利語 (義大利)
	 */
	Italian_Italy = 'it-IT',

	/**
	 * 日語 (日本)
	 */
	Japanese_Japan = 'ja-JP',

	/**
	 * 爪哇語 拉丁文 (印尼)
	 */
	Javanese_Latin_Indonesia = 'jv-ID',

	/**
	 * 喬治亞語 (喬治亞)
	 */
	Georgian_Georgia = 'ka-GE',

	/**
	 * 哈薩克語 (哈薩克)
	 */
	Kazakh_Kazakhstan = 'kk-KZ',

	/**
	 * 高棉語 (柬埔寨)
	 */
	Khmer_Cambodia = 'km-KH',

	/**
	 * 坎那達語 (印度)
	 */
	Kannada_India = 'kn-IN',

	/**
	 * 韓語 (韓國)
	 */
	Korean_Korea = 'ko-KR',

	/**
	 * 寮國語 (寮國)
	 */
	Lao_Laos = 'lo-LA',

	/**
	 * 立陶宛語 (立陶宛)
	 */
	Lithuanian_Lithuania = 'lt-LT',

	/**
	 * 拉脫維亞語 (拉脫維亞)
	 */
	Latvian_Latvia = 'lv-LV',

	/**
	 * 馬其頓語 (北馬其頓)
	 */
	Macedonian_North_Macedonia = 'mk-MK',

	/**
	 * 馬拉雅拉姆語 (印度)
	 */
	Malayalam_India = 'ml-IN',

	/**
	 * 蒙古語 (蒙古)
	 */
	Mongolian_Mongolia = 'mn-MN',

	/**
	 * 馬拉地語 (印度)
	 */
	Marathi_India = 'mr-IN',

	/**
	 * 馬來語 (馬來西亞)
	 */
	Malay_Malaysia = 'ms-MY',

	/**
	 * 馬爾他語 (馬爾他)
	 */
	Maltese_Malta = 'mt-MT',

	/**
	 * 緬甸語 (緬甸)
	 */
	Burmese_Myanmar = 'my-MM',

	/**
	 * 挪威語 博克馬爾 (挪威)
	 */
	Norwegian_Bokmål_Norway = 'nb-NO',

	/**
	 * 尼泊爾語 (尼泊爾)
	 */
	Nepali_Nepal = 'ne-NP',

	/**
	 * 荷蘭語 (比利時)
	 */
	Dutch_Belgium = 'nl-BE',

	/**
	 * 荷蘭語 (荷蘭)
	 */
	Dutch_Netherlands = 'nl-NL',

	/**
	 * 奧里亞語 (印度)
	 */
	Odia_India = 'or-IN',

	/**
	 * 旁遮普語 (印度)
	 */
	Punjabi_India = 'pa-IN',

	/**
	 * 波蘭語 (波蘭)
	 */
	Polish_Poland = 'pl-PL',

	/**
	 * 普什圖語 (阿富汗)
	 */
	Pashto_Afghanistan = 'ps-AF',

	/**
	 * 葡萄牙語 (巴西)
	 */
	Portuguese_Brazil = 'pt-BR',

	/**
	 * 葡萄牙語 (葡萄牙)
	 */
	Portuguese_Portugal = 'pt-PT',

	/**
	 * 羅馬尼亞語 (羅馬尼亞)
	 */
	Romanian_Romania = 'ro-RO',

	/**
	 * 俄語 (俄羅斯)
	 */
	Russian_Russia = 'ru-RU',

	/**
	 * 僧伽羅語 (斯里蘭卡)
	 */
	Sinhala_Sri_Lanka = 'si-LK',

	/**
	 * 斯洛伐克語 (斯洛伐克)
	 */
	Slovak_Slovakia = 'sk-SK',

	/**
	 * 斯洛維尼亞語 (斯洛維尼亞)
	 */
	Slovenian_Slovenia = 'sl-SI',

	/**
	 * 索馬利語 (索馬利亞)
	 */
	Somali_Somalia = 'so-SO',

	/**
	 * 阿爾巴尼亞語 (阿爾巴尼亞)
	 */
	Albanian_Albania = 'sq-AL',

	/**
	 * 塞爾維亞語 西里爾文 (塞爾維亞)
	 */
	Serbian_Cyrillic_Serbia = 'sr-RS',

	/**
	 * 瑞典語 (瑞典)
	 */
	Swedish_Sweden = 'sv-SE',

	/**
	 * 斯瓦希里語 (肯亞)
	 */
	Kiswahili_Kenya = 'sw-KE',

	/**
	 * 斯瓦希里語 (坦桑尼亞)
	 */
	Kiswahili_Tanzania = 'sw-TZ',

	/**
	 * 泰米爾語 (印度)
	 */
	Tamil_India = 'ta-IN',

	/**
	 * 泰盧固語 (印度)
	 */
	Telugu_India = 'te-IN',

	/**
	 * 泰語 (泰國)
	 */
	Thai_Thailand = 'th-TH',

	/**
	 * 土耳其語 (土耳其)
	 */
	Turkish_Türkiye = 'tr-TR',

	/**
	 * 烏克蘭語 (烏克蘭)
	 */
	Ukrainian_Ukraine = 'uk-UA',

	/**
	 * 烏爾都語 (印度)
	 */
	Urdu_India = 'ur-IN',

	/**
	 * 烏茲別克語 拉丁文 (烏茲別克)
	 */
	Uzbek_Latin_Uzbekistan = 'uz-UZ',

	/**
	 * 越南語 (越南)
	 */
	Vietnamese_Vietnam = 'vi-VN',

	/**
	 * 中文 吳語 簡體
	 */
	Chinese_Wu_Simplified = 'wuu-CN',

	/**
	 * 中文 粵語 簡體
	 */
	Chinese_Cantonese_Simplified = 'yue-CN',

	/**
	 * 中文 普通話 簡體
	 */
	Chinese_Mandarin_Simplified = 'zh-CN',

	/**
	 * 中文 冀魯官話 簡體
	 */
	Chinese_Jilu_Mandarin_Simplified = 'zh-CN-shandong',

	/**
	 * 中文 西南官話 簡體
	 */
	Chinese_Southwestern_Mandarin_Simplified = 'zh-CN-sichuan',

	/**
	 * 中文 粵語 繁體
	 */
	Chinese_Cantonese_Traditional = 'zh-HK',

	/**
	 * 中文 台灣普通話 繁體
	 */
	Chinese_Taiwanese_Mandarin_Traditional = 'zh-TW',

	/**
	 * 祖魯語 (南非)
	 */
	isiZulu_South_Africa = 'zu-ZA',
}
